module.exports = __webpack_public_path__ + "static/media/expert-karina.d408c67b.png";